<template>
  <b-modal
    id="upload-modal"
    ref="upload-modal"
    size="md"
    scrollable
    hide-footer
    centered
    :title="$t('actions.import')"
    @hide="hideModal"
  >
    <div class="d-flex align-items-center justify-content-center flex-column">
      <form
        ref="uploadModalForm"
        class="w-100 d-flex justify-content-center align-items-center flex-column"
      >
        <div class="w-100 d-flex justify-content-center">
          <input
            id="file"
            type="file"
            @change="fileUploaded()"
            ref="file"
            name="file"
            accept=".csv"
            class="d-none"
          />
          <label
            for="file"
            class="d-flex align-items-center justify-content-between"
          >
            <div
              class="choose-file-btn rounded px-5 py-2 fs-14 shadow-sm border border-primary align-items-center justify-content-center"
            >
              <span>{{ $t("actions.pick_file") }}</span>
            </div>
            <span class="label fs-14 text-form-grey ml-2">
              <span v-if="fileUploaded">{{ fileName }}</span>
            </span>
          </label>
        </div>
        <div class="content mt-3">
          <div v-if="!loading">
            <div
              v-for="(error, index) in formErrors"
              :key="index"
              class="d-flex align-items-start flex-wrap flex-column justify-content-center mb-2"
            >
              <p class="d-flex align-items-center mb-1">
                {{ $t("messages.upload_error_product_line") }}
                <span class="font-weight-bold ml-1">{{ index }}:</span>
              </p>
              <div
                v-for="(data, index) in error"
                :key="index"
                class="d-flex flex-column align-items-center"
              >
                <p v-if="data.field" class="d-flex align-items-center mb-1">
                  <font-awesome-icon
                    :icon="faCircle"
                    class="text-danger mr-1 dot"
                  />
                  <span>{{ $t("messages.upload_error") }}</span>
                  <span class="font-weight-bold mx-1">
                    {{ data.field }}
                  </span>
                </p>
                <p v-if="data.empty" class="d-flex align-items-center mb-1">
                  <font-awesome-icon
                    :icon="faCircle"
                    class="text-danger mr-1 dot"
                  />
                  <span v-if="data.empty">{{ $t(data.empty) }}</span>
                </p>
              </div>
            </div>
          </div>
          <div v-else>
            <spinner />
          </div>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <b-button
            variant="primary"
            @click.stop="submit()"
            class="mt-4"
            :disabled="!checkFile"
          >
            {{ $t("actions.submit") }}
          </b-button>
        </div>
      </form>
    </div>
  </b-modal>
</template>


<script>
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import api from '@/api/products'
import model from '@/models/products'
import actions from '@/mixins/list'

export default {
  components: {
    FontAwesomeIcon
  },
  mixins: [actions],
  data: () => ({
    api,
    loading: false,
    form: {
      file: null
    },
    fileName: null,
    formErrors: [],
    fields: model.fields,
    filters: JSON.parse(JSON.stringify(model.filters)),
    faCircle
  }),
  computed: {
    formData() {
      var data = new FormData()
      Object.entries(this.form).forEach(([key, value]) =>
        data.append(
          key,
          typeof value === 'object' && ['file'].indexOf(key) === -1
            ? JSON.stringify(value)
            : value
        )
      )
      return data
    },
    checkFile() {
      return this.form.file !== null
    }
  },
  methods: {
    async submit() {
      this.loading = true
      this.formErrors = []

      const response = await this.api.upload(this.formData)

      this.$refs.uploadModalForm.reset()

      if (!(response && response.data && response.data.length > 0)) {
        this.$toasted.success(
          this.$t('messages.created_plural', {
            item: this.$t('menu.products')
          })
        )
        await Promise.all([this.getList()])
        this.$emit('updateItems', this.items)
        this.$refs['upload-modal'].hide()
        this.loading = false
      } else {
        const errors = response.data
        this.showErrors(errors)
      }
    },
    fileUploaded() {
      this.form.file = this.$refs.file.files[0]
      this.fileName = this.form.file.name
    },
    showErrors(errors) {
      const uploadErrors = []

      errors.map(error => {
        const productLine = error.line

        if (typeof error.errors === 'object') {
          Object.keys(error.errors).map(function(field) {
            const errorField = field
            uploadErrors.push({
              line: productLine,
              field: errorField,
              empty: false
            })
          })
        } else {
          uploadErrors.push({
            line: productLine,
            field: false,
            empty: error.errors
          })
        }
      })

      const groupBy = (key, array) =>
        array.reduce((objectsByLine, obj) => {
          const value = obj[key]
          objectsByLine[value] = (objectsByLine[value] || []).concat(obj)
          return objectsByLine
        }, {})

      this.formErrors = groupBy('line', uploadErrors)

      this.$toasted.error(this.$t('messages.error'))
      this.loading = false
    },
    hideModal() {
      this.formErrors = []
      this.form.file = null
      this.fileName = null
    }
  }
}
</script>
<style lang="scss" scoped>
.file {
  width: 68%;
}

.content {
  max-height: 25rem;
  overflow-y: auto;
}

.dot {
  width: 0.5rem;
}

.choose-file-btn {
  cursor: pointer;
}
</style>